import React from 'react';
import { shallowEqual } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { root } from '~/preloaded';
import { PERMISSIONS, TREASURY_TABS } from '~/constants';
import useMount from '~/hooks/useMount';
import { ROUTES_MAP } from '~/router/routes';
import { useAppDispatch, useAppSelector } from '~/store';
import { actionsTreasury, getTransactionsThunk } from '~/Actions/ActionTreasury';

import RegularRewards from './RegularRewards/RegularRewards';

import type { RootState } from '~/store';

const stateSelector = (state: RootState) => {
  return {
    clanId: state.currentAccount.clanId,
    permissions: state.currentAccount.permissions,
  };
};

const TreasuryRewards: React.FC = () => {
  const { permissions } = useAppSelector(stateSelector, shallowEqual);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useMount(() => {
    dispatch(actionsTreasury.setSelectedTab(TREASURY_TABS.REWARDS));
    dispatch(getTransactionsThunk(false));
  });

  const canDistribute = permissions?.indexOf(PERMISSIONS.DIVIDE_PROFITS) !== -1;

  const handleNavigateToTreasury = () => {
    navigate(`${root}${ROUTES_MAP.PROFILE}?buildingId=treasury`);
  };

  return <RegularRewards navigateToTreasuryBuilding={handleNavigateToTreasury} canDistribute={canDistribute} />;
};

export default TreasuryRewards;
